import React from 'react';
import { ReactComponent as CancelIconSvg } from '@images/common/x-icon.svg';

export const CloseIcon = () => {
  return <CancelIconSvg id='close-icon-id' />;
};
